import * as Dtos from "../dtos/Tmd.dtos";
import {  IFormFilter } from "../reducers/index";

export const
    LoadQuillDocumentImageById: IQuillDocumentImageLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_QUILLDOCUMENTIMAGE_LOAD_BY_ID,
            id
        }
    },
    LoadQuillDocumentImageByQuillDocumentId: IQuillDocumentImageLoadByQuillDocumentIdActionCreator = (quillDocumentId) => {
        return {
            type: ACTION_QUILLDOCUMENTIMAGE_LOAD_BY_QUILLDOCUMENTID,
            quillDocumentId
        }
    },
    LoadSuccess: IQuillDocumentImageLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_QUILLDOCUMENTIMAGE_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IQuillDocumentImageLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_QUILLDOCUMENTIMAGE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveQuillDocumentImage: IQuillDocumentImageSaveActionCreator = (formData) => {
        return {
            type: ACTION_QUILLDOCUMENTIMAGE_SAVE,
            formData
        }
    },
    SaveSuccess: IQuillDocumentImageSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_QUILLDOCUMENTIMAGE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IQuillDocumentImageSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_QUILLDOCUMENTIMAGE_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateQuillDocumentImage: IQuillDocumentImageCreateActionCreator = (quillDocumentId) => {
        return {
            type: ACTION_QUILLDOCUMENTIMAGE_CREATE,
            quillDocumentId
        }
    },
    CreateSuccess: IQuillDocumentImageCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_QUILLDOCUMENTIMAGE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IQuillDocumentImageCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_QUILLDOCUMENTIMAGE_CREATE_FAILURE,
            responseStatus
        }
    },

    Clear: IQuillDocumentImageClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_QUILLDOCUMENTIMAGE_CLEAR,
            propertiesToClear
        }
    },
    Filter: IQuillDocumentImageFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_QUILLDOCUMENTIMAGE_FILTER,
            formFilter
        }
    };

export const
    ACTION_QUILLDOCUMENTIMAGE_LOAD_BY_ID = "ACTION_QUILLDOCUMENTIMAGE_LOAD_BY_ID",
    ACTION_QUILLDOCUMENTIMAGE_LOAD_BY_QUILLDOCUMENTID = "ACTION_QUILLDOCUMENTIMAGE_LOAD_BY_QUILLDOCUMENTID",
    ACTION_QUILLDOCUMENTIMAGE_LOAD_SUCCESS = "ACTION_QUILLDOCUMENTIMAGE_LOAD_SUCCESS",
    ACTION_QUILLDOCUMENTIMAGE_LOAD_FAILURE = "ACTION_QUILLDOCUMENTIMAGE_LOAD_FAILURE",

    ACTION_QUILLDOCUMENTIMAGE_SAVE = "ACTION_QUILLDOCUMENTIMAGE_SAVE",
    ACTION_QUILLDOCUMENTIMAGE_SAVE_SUCCESS = "ACTION_QUILLDOCUMENTIMAGE_SAVE_SUCCESS",
    ACTION_QUILLDOCUMENTIMAGE_SAVE_FAILURE = "ACTION_QUILLDOCUMENTIMAGE_SAVE_FAILURE",

    ACTION_QUILLDOCUMENTIMAGE_CREATE = "ACTION_QUILLDOCUMENTIMAGE_CREATE",
    ACTION_QUILLDOCUMENTIMAGE_CREATE_SUCCESS = "ACTION_QUILLDOCUMENTIMAGE_CREATE_SUCCESS",
    ACTION_QUILLDOCUMENTIMAGE_CREATE_FAILURE = "ACTION_QUILLDOCUMENTIMAGE_CREATE_FAILURE",

    ACTION_QUILLDOCUMENTIMAGE_CLEAR = "ACTION_QUILLDOCUMENTIMAGE_CLEAR",

    ACTION_QUILLDOCUMENTIMAGE_FILTER = "ACTION_QUILLDOCUMENTIMAGE_FILTER";

export interface IQuillDocumentImageLoadSuccessAction {
    type: "ACTION_QUILLDOCUMENTIMAGE_LOAD_SUCCESS";
    formData: Dtos.QuillDocumentImage | Dtos.QuillDocumentImage[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IQuillDocumentImageLoadSuccessActionCreator {
    (
        formData: Dtos.QuillDocumentImage | Dtos.QuillDocumentImage[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IQuillDocumentImageLoadSuccessAction;
}

export interface IQuillDocumentImageLoadFailureAction {
    type: "ACTION_QUILLDOCUMENTIMAGE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IQuillDocumentImageLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IQuillDocumentImageLoadFailureAction;
}

export interface IQuillDocumentImageLoadByIdAction {
    type: "ACTION_QUILLDOCUMENTIMAGE_LOAD_BY_ID";
    id: number;
}

export interface IQuillDocumentImageLoadByIdActionCreator {
    (id: number): IQuillDocumentImageLoadByIdAction;
}

export interface IQuillDocumentImageLoadByQuillDocumentIdAction {
    type: "ACTION_QUILLDOCUMENTIMAGE_LOAD_BY_QUILLDOCUMENTID";
    quillDocumentId: number;
}

export interface IQuillDocumentImageLoadByQuillDocumentIdActionCreator {
    (quillDocumentId: number): IQuillDocumentImageLoadByQuillDocumentIdAction;
}


export interface IQuillDocumentImageSaveAction {
    type: "ACTION_QUILLDOCUMENTIMAGE_SAVE";
    formData: Dtos.QuillDocumentImage;

}

export interface IQuillDocumentImageSaveActionCreator {
    (
        formData: Dtos.QuillDocumentImage
    ): IQuillDocumentImageSaveAction;
}

export interface IQuillDocumentImageSaveSuccessAction {
    type: "ACTION_QUILLDOCUMENTIMAGE_SAVE_SUCCESS";
    formData: Dtos.QuillDocumentImage;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IQuillDocumentImageSaveSuccessActionCreator {
    (
        formData: Dtos.QuillDocumentImage,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IQuillDocumentImageSaveSuccessAction;
}

export interface IQuillDocumentImageSaveFailureAction {
    type: "ACTION_QUILLDOCUMENTIMAGE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IQuillDocumentImageSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IQuillDocumentImageSaveFailureAction;
}

export interface IQuillDocumentImageCreateAction {
    type: "ACTION_QUILLDOCUMENTIMAGE_CREATE";
    quillDocumentId: number;
}

export interface IQuillDocumentImageCreateActionCreator {
    (quillDocumentId: number): IQuillDocumentImageCreateAction
}

export interface IQuillDocumentImageCreateSuccessAction {
    type: "ACTION_QUILLDOCUMENTIMAGE_CREATE_SUCCESS";
    formData: Dtos.QuillDocumentImage;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IQuillDocumentImageCreateSuccessActionCreator {
    (
        formData: Dtos.QuillDocumentImage,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IQuillDocumentImageCreateSuccessAction;
}

export interface IQuillDocumentImageCreateFailureAction {
    type: "ACTION_QUILLDOCUMENTIMAGE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IQuillDocumentImageCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IQuillDocumentImageCreateFailureAction;
}

export interface IQuillDocumentImageClearAction {
    type: "ACTION_QUILLDOCUMENTIMAGE_CLEAR";
    propertiesToClear?: string[];
}

export interface IQuillDocumentImageClearActionCreator {
    (propertiesToClear?: string[]): IQuillDocumentImageClearAction;
}

export interface IQuillDocumentImageFilterActionCreator {
    (formFilter: IFormFilter): IQuillDocumentImageFilterAction;
}

export interface IQuillDocumentImageFilterAction {
    type: "ACTION_QUILLDOCUMENTIMAGE_FILTER";
    formFilter: IFormFilter;
}

export type QuillDocumentImageAction =
    IQuillDocumentImageLoadByIdAction |
    IQuillDocumentImageLoadByQuillDocumentIdAction |
    IQuillDocumentImageLoadFailureAction |
    IQuillDocumentImageLoadSuccessAction |
    IQuillDocumentImageSaveAction |
    IQuillDocumentImageSaveSuccessAction |
    IQuillDocumentImageSaveFailureAction |
    IQuillDocumentImageCreateAction |
    IQuillDocumentImageCreateSuccessAction |
    IQuillDocumentImageCreateFailureAction |
    IQuillDocumentImageClearAction |
    IQuillDocumentImageFilterAction;
